import { render, staticRenderFns } from "./SkillScore.vue?vue&type=template&id=242d9c20&scoped=true&"
import script from "./SkillScore.vue?vue&type=script&lang=js&"
export * from "./SkillScore.vue?vue&type=script&lang=js&"
import style0 from "./SkillScore.vue?vue&type=style&index=0&id=242d9c20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242d9c20",
  null
  
)

export default component.exports